import { GameConfiguratorSingleton } from '@services/GameConfiguratorSingleton';
import { COLORS, FONT_FAMILY, SIZES } from '@static/styles';
import { createFontStyle } from '@utils/createFontStyle';
var Toolbar = /** @class */ (function () {
    function Toolbar() {
        var _this = this;
        this.draw = function () {
            _this._gameConfigurator.context.fillStyle = COLORS.toolbarColor;
            _this._gameConfigurator.context.fillRect(0, 0, _this._controlsBar.width, _this._controlsBar.height);
            _this._gameConfigurator.context.fillStyle = COLORS.textColor;
            _this._gameConfigurator.context.font = createFontStyle(SIZES.headerFontSize, FONT_FAMILY);
            _this._gameConfigurator.context.textAlign = 'left';
            _this._gameConfigurator.context.textBaseline = 'top';
            _this._gameConfigurator.context.fillText("Balance: " + _this._gameConfigurator.balance, 10, 10);
        };
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        this._controlsBar = this._gameConfigurator.controlsBar;
    }
    return Toolbar;
}());
export { Toolbar };
